import styles from './Divider.module.scss';
import { DividerProps } from './types';

export function Divider({ top = 0, bottom = 0, disableBackground, className }: DividerProps) {
	return (
		<hr
			className={`${styles.dividerWrapper}${className ? ' ' + className : ''}`}
			style={{
				marginTop: `${top / 16}rem`,
				marginBottom: `${bottom / 16}rem`,
				...(disableBackground !== false ? { background: 'none' } : {}),
			}}
		/>
	);
}
